import MessageEditor from "./MessageEditor";

export default MessageEditor;
